import { render, staticRenderFns } from "./FacturaRapidaItems.vue?vue&type=template&id=63e19dc2&"
import script from "./FacturaRapidaItems.vue?vue&type=script&lang=js&"
export * from "./FacturaRapidaItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports